import { Inject, Injectable, Optional } from '@angular/core';
import { EventData, EventInteractionService } from '@mare-common/ngx-mare-common';

declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class DelfiChannelService {
  

  private channel!: BroadcastChannel;

  constructor(
    private eventInteractionService: EventInteractionService,
    @Optional()@Inject('channelName') public channelName: string
  ) {
    console.log('DelfiChannelService channelName', channelName)
    this.channel = new BroadcastChannel(channelName || 'delfi-channel');

    this.channel.onmessage = (event) => {
      console.log('DelfiChannelService onmessage', event)
      this.eventInteractionService.publishData({
        event: 'delfiChannel',
        data: event.data
      });
    };

    this.eventInteractionService.getObservable().subscribe((event: EventData) => {
      if(event.event === 'sendDelfiChannel') {
        console.log('DelfiChannelService delfiChannel', event.data)
        // this.channel.postMessage(event.data);
        this.sendData(event.data);
      }
    });

   }

   sendData(event: any) {
    this.channel.postMessage(event);
  }
}
